import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import toast from "react-hot-toast";
import { Calendar } from "react-multi-date-picker";
import SelectMulti from "react-select";
import { Get, Set } from "../../../../Request";
import BoxShadow from "../BoxShadow";
import Cards from "../Cards";
import { icons } from "../ClassIcons";
import ClassTimeTable from "../ClassTimeTable";
import DropFile from "../DropFile";
import Loading from "../Loading";
import Region from "../Region";
import { useNesdata } from "./hook.js";
import "./style.css";
import { styles } from "./styles";
import CreateRegion from "../CreateRegion";
import EditorReact from "../EditorReact";
import CheckEditor from "../CheckEditor";
import SeoKeywords from "../SeoKeywords";
import { randomBetweenToNumber, removeSepMoney, sepJustMoney } from "../../Function";
const Form = ({
  form,
  initialeState,
  header,
  btnName,
  submit,
  loading,
  value,
  edit,
  nested = false,
  modal,
  textEditor,
  classBox,
  classChildBox,
  shadowClass,
  isApp
}) => {
  const [formText, setFormText] = useState({});
  const [input, setInput] = useState({ images_alt: [], loading: true });
  const [isLast, setIsLast] = useState(false);
  const [editor, setEditor] = useState({});
  const { loadingData, nesdata, get, getNesdata } = useNesdata();
  useEffect(() => {
    if (nested) {
      getNesdata(nested);
    }
  }, []);
  useEffect(() => {
    setInput({
      loading: false,
      seo: { seoKeyword: [] },
      images_alt: [],
      ...input,
      ...initialeState,
      ...value,
      images_alt: value && value.images_alt ? value.images_alt : [],
    });
  }, [value]);

  const check = () => {
    let result = true;
    let emptys = [];
    if (!edit) {
      form &&
        form.map(element => {
          if (element.keyname && !element.noNeed && element.input !== "file") {
            if (input[element.name]) {
              if (!input[element.name][element.keyname]) {
                result = false;
                emptys.push(element.label);
              }
            } else {
              result = false;
              emptys.push(element.label);
            }
          } else {
            if (!element.noNeed && element.input !== "file") {
              if (element.name in input) {
                if (!input[element.name]) {
                  result = false;
                  emptys.push(element.label);
                }
              } else {
                result = false;
                emptys.push(element.label);
              }
            }
          }
        });
    }

    setIsLast(true);

    return {
      status: result,
      message: emptys,
    };
  };
  const checkValidate = key => {
    let result = true;
    if (input[key]) {
      result = false;
    }
    return result;
  };
  const renderError = () => {
    toast.error(`${check()["message"].map(filed => filed)} وارد نشده است`);
  };
  //

  const handleChange = (value, ele) => {

    if (ele.keyname) {
      if (input[ele.name]) {
        setInput({
          ...input,
          [ele.name]: { ...input[ele.name], [ele.keyname]: value },
        });
      } else {
        setInput({
          ...input,
          [ele.name]: { [ele.keyname]: value },
        });
      }
    } else {
      setInput({
        ...input,
        [ele.name]: value,
      });
    }
  };

  const handleValue = ele => {
    if (ele.keyname) {
      if (input[ele.name] && input[ele.name][ele.keyname]) {
        return input[ele.name][ele.keyname];
      } else {
        return "";
      }
    } else {
      if (input[ele.name]) {
        return input[ele.name];
      } else {
        return "";
      }
    }
  };

  const changeMultiSelect = (data, element) => {

    setInput({ ...input, [element.name]: data });
  };
  const isValid = async (data, url) => {
    return await Get({ url, data });
  };

  const convertObjToStyle = key => {
    switch (key) {
      case "maxWidth":
        return "max-width";
      case "backgroundColor":
        return "background-color";
      case "borderRadius":
        return "border-radius";
        break;
      case "textAlign":
        return "text-align";
        break;
      default:
        break;
    }
  };
  const chekElemet = element => {
    switch (element.input) {
      case "select":
        if (element.nested) {
          return (
            <div className={`my-2 ${element.size}`}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                  {element.label}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={element.label}
                  onChange={({ target: { value } }) => {
                    handleChange(value, element);
                  }}
                  value={handleValue(element)}
                >
                  {get(element.nested) &&
                    get(element.nested).map((option, key) => {
                      return (
                        <MenuItem value={option.id} key={key}>
                          {option.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
          );
        } else {
          return (
            <div className={`my-2 ${element.size}`}>
              <FormControl fullWidth size="small" value={input[element.name]}>
                <InputLabel id="demo-simple-select-label">
                  {element.label}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={element.label}
                  onChange={({ target: { value } }) => {
                    handleChange(value, element);
                  }}
                  value={handleValue(element)}
                >
                  {element.options.map((option, key) => {
                    return (
                      <MenuItem value={option.id} key={key}>
                        {" "}
                        {option.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          );
        }
      case "textarea":
        if (element.keyname && element.keyname == "seoKeyword") {
          return (
            <SeoKeywords
              options={{
                key: "seoKeyword",
                nested: "seo",
              }}
              element={element}
              form={input}
              setForm={setInput}
            />
          );
        }
        return (
          <div className={`my-2 ${element.size}`}>
            <TextField
              fullWidth
              size="small"
              error={isLast && checkValidate(element.name)}
              value={handleValue(element)}
              label={element.label}
              multiline
              rows={2}
              className="input-control input-input txtArea"
              onChange={({ target: { value } }) => {
                handleChange(value, element);
              }}
              defaultValue={element.value}
            />
          </div>
        );
      case "region":
        return (
          <div className={`my-2 ${element.col}`}>
            <Region data={input} set={setInput} />
          </div>
        );
      case "file":
        return (
          <div className={`my-2 ${element.size}`}>
            <label style={{ fontSize: "10px" }}>{element.label}</label>
            <DropFile
              // images={value && input[element.name]}
              accept={element.accept}
              set={e => {
                setInput({ ...input, [element.name]: e });
              }}
            />
            {element.alt && (
              <SeoKeywords
                form={input}
                setForm={setInput}
                options={{
                  title: "متن جایگزین تصاویر",
                  key: "images_alt",
                  nested: false,
                }}
              />
            )}
          </div>
        );
      case "ckeditor":
        return (
          <>
            {
              handleValue(element)
              && <CheckEditor
                element={element}
                handleChange={handleChange}
                data={handleValue(element)}
                input={input}
                setInput={setInput}
                editor={editor}
                setEditor={setEditor}
              />
            }
            {
              !handleValue(element)
              && <CheckEditor
                classBox="initHeight"
                element={element}
                handleChange={handleChange}
                data={element.brData ? <p><br /><br /><br /></p> : handleValue(element)}
                input={input}
                setInput={setInput}
                editor={editor}
                setEditor={setEditor}
              />
            }

          </>
        );

      case "selectTable":
        return (
          <div className={`my-2 ${element.size}`}>
            {/* <label htmlFor="">{element.label}</label> */}
            <SelectMulti
              placeholder={element.label}
              style={{ fontSize: "10" }}
              isMulti={true}
              defaultValue={handleValue(element)}
              value={handleValue(element)}
              onChange={e => {
                changeMultiSelect(e, element);
              }}
              options={nesdata && nesdata[element.nested]}
            />
          </div>
        );
      case "region":
        return (
          <div className={`my-2 ${element.size}`}>
            <Region
              data={input}
              set={setInput}
              edit={edit ? "dadawd" : false}
            />
          </div>
        );
      case "createRegion":
        return (
          <div className={`my-2 ${element.size}`}>
            <CreateRegion data={input} set={setInput} />
          </div>
        );
      case "card":
        return (
          <div className={`my-2 ${element.size}`}>
            <Cards input={input} set={setInput} element={element} />
          </div>
        );
      case "timeTable":
        return (
          <div className={`my-2 ${element.size}`}>
            <ClassTimeTable input={input} set={setInput} element={element} />
          </div>
        );
      case "date":
        return (
          <div className={`my-2 ${element.size}`}>
            <label>{element.label}</label>
            <Calendar
              onChange={data => {
                handleChange(data, element);
              }}
              calendar={persian}
              locale={persian_fa}
            />
          </div>
        );
      case "icons":
        return (
          <div className={`my-2 ${element.size} d-flex`}>
            <div className="row">
              {icons.map((icon, i) => {
                return (
                  <div className="col-2 my-2" key={i}>
                    <button
                      style={{ backgroundColor: "transparent", border: "none" }}
                      onClick={() => {
                        setInput({ ...input, icon });
                      }}
                    >
                      <i
                        style={{
                          fontSize: 60,
                          margin: 10,
                          padding: 10,
                          color:
                            input.icon && input.icon === icon ? "#E42A3E" : "",
                        }}
                        className={`${icon}`}
                      ></i>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        );
      case "switch":
        return (
          <div className={`my-2 ${element.size}`}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography>غیر فعال</Typography>
              <Switch
                checked={input.checked}
                inputProps={{ "aria-label": "controlled" }}
                onChange={() => {
                  if (input.status === "active") {
                    setInput({
                      ...input,
                      checked: !input.checked,
                      status: "deactive",
                    });
                  } else {
                    setInput({
                      ...input,
                      checked: !input.checked,
                      status: "active",
                    });
                  }
                }}
              />
              <Typography> فعال</Typography>
            </Stack>
          </div>
        );
      case "EditorReact":
        return <EditorReact form={formText} setForm={setFormText} />;
      default:
        return (
          <div className={`my-2 ${element.size + " " + element.classNames}`} style={{}}>
            <TextField
              fullWidth
              error={isLast && checkValidate(element.name)}
              label={element.label}
              InputProps={{
                className: styles.resize,
              }}
              disabled={element.disabled}
              size="small"
              defaultValue={element.value}
              className={styles.textField}
              value={element.sepMoney ? sepJustMoney(handleValue(element)) : handleValue(element)}
              onChange={({ target: { value } }) => {
                handleChange(element.sepMoney ? removeSepMoney(value) : value, element);
              }}
              onBlur={() => {
                if (element.check) {
                  isValid(input, element.check).then(res => {
                    if (res.user) {
                      setInput(res);
                      toast.success("کاربر یافت شد");
                    } else {
                    }
                  });
                }
              }}
            />
          </div>
        );
        break;
    }
  };
  const generateHtml = () => {
    return "";
  };
  const addStyle = style => {
    let res = "";
    Object.keys(style).map(key => {
      if (key) {
        res = res + `${key}:${style[key]};`;
      }
    });
    return res;
  };
  const addTag = element => {
    switch (element.tag) {
      case "img":
        return `<img  src="${element.value}" alt="${element.alt
          }" style="${addStyle(element.style)}"/>`;
        break;

      default:
        return `<${element.tag}>${element.value}</${element.tag}>`;
    }
  };
  const getTextEditorData = () => {
    let res = "";
    [...formText.values].map(element => {
      res = res + addTag(element);
    });
    return res;
  };
  const hasEditor = () => {
    let isIn = false;
    form.map(ele => {
      if (ele.input == "ckeditor") {
        isIn = ele.name;
      }
    });
    return isIn;
  };
  const renderEditor = (data, key) => {
    return { ...data, [key]: data[key] };
  };
  const renderSubmit = () => {
    if (check()["status"]) {
      if (hasEditor()) {
        submit(renderEditor(input, hasEditor()));
      } else {
        submit(input);
      }
    } else {
      renderError();
    }
  };
  if (nested && loadingData) {
    return <Loading count={1} col={12} />;
  }
  if (modal) {
    return (
      <div
        className=""
        style={{
          padding: "0 1rem",
        }}
      >
        <div className="row" style={{}}>
          {form.map(element => chekElemet(element))}
        </div>
        <div className="row justify-content-between my-3">
          <div className="col">
            <div className="row justify-content-end">
              <div className="col-6 col-md-2 d-flex justify-content-end">
                <Button
                  variant="contained"
                  // disabled={loading}
                  onClick={() => {
                    check()["status"] ? submit(input) : renderError();
                  }}
                >
                  {loading ? "در حال پردازش" : btnName}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <BoxShadow
      style={{
        padding: "0",
      }}
      className={shadowClass}
    >
      <div className={" " + (classBox)}>
        {header && <div
          className="row mb-4 "
          style={{ borderBottom: "1px solid #e1e5eb" }}
        >
          <div className="col-10">
            <h6
              style={{
                fontSize: "1rem !important",
                lineHeight: "1.5rem",
                padding: "1rem",
              }}
            >
              {header}
            </h6>
          </div>
        </div>}
        <div
          className={classChildBox}
          style={{
            padding: "0 1rem",
          }}
        >
          <div className="row" style={{}}>
            {form && form.map(element => chekElemet(element))}
          </div>
          <div className="row justify-content-between my-3">
            <div className="col">
              <div className="row justify-content-end">
                <div className={"d-flex justify-content-end " + (isApp ? "col-12" : "col-6 col-md-4")}>
                  <Button
                    style={{ width: isApp && "100%" }}
                    variant="contained"
                    // disabled={loading}
                    // EditorReact
                    onClick={() => {
                      renderSubmit();
                    }}
                  >
                    {loading ? "در حال پردازش" : btnName}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BoxShadow>
  );
};

export default Form;